import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';
import user_tracker from '../../../usertracker'
import {
  BasicSelect
} from 'vue-search-select'
import Multiselect from 'vue-multiselect'

export default {
  name: 'allocate-active-hub',
  components: {
    VueElementLoading,
    BasicSelect,
    Multiselect
  },
  props: [],
  data() {
    return {
      hubLoading: false,
      hubdetails: [],
      IsActive: [],
      userid: '',
      hubname: '',
      hubid: '',
      hubnameerror: '',
      hublist: [],
      hubitem: {
        value: '',
        text: ''
      },
      hubloader:''
    }
  },
  computed: {},
  mounted() {
    var userTokenEncrypt = window.localStorage.getItem('userToken')
    var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
    var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userid = userdetail[0].email;
    // user_tracker.checkUserIP(userdetail[0], "AllocateHubToUser", this.$route.path);
    this.getHubList();
    //this.getHubDetailslist();
  },
  methods: {
    getHubList() {
      this.input = ({})
      this.hubloader = 'Loading Hub...'
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubloader = ''
          var HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName,
            })
          }
        }, error => {
          console.error(error)
        })
    },
    getHubDetailslist(hubid) {
      this.hubLoading = true
      var hubdetails = [];
      this.hubdetails = [];
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'getActiveInactiveHubs',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = false
          if (result.data.ResultCode == 100) {
            var hubdetails = result.data.ResponseData
            this.hubdetails = hubdetails.filter(function(e) {
              return e.HubID == hubid;
            });
            this.IsActive = hubdetails.filter(data => {
              if (data.IsActive == true) {
                return data
              }
            })
          } else {
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.hubLoading = false
          console.error(error)
        })
    },
    setSelectedHub(hubitem) {
      this.hubid = hubitem.value;
      this.hubname = hubitem.text;
      this.hubitem = hubitem;
      if (this.hubname == '') {
        this.hubnameerror = 'Select Hub Name'
      } else {
        this.hubnameerror = ''
      }
    },
    clearSelectedOption() {
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hubnameerror = ''
    },
    searchHub(hubid) {
      if (hubid != '') {
        this.hubnameerror = ""
        this.getHubDetailslist(hubid);
      } else {
        this.hubnameerror = "Select Hub Name"
        return false;
      }
    },
    resetFlt() {
      this.hubname = ''
      this.hubid = ''
      this.hubnameerror = ''
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hubloader= ''
      //this.getHubDetailslist()
    },
    allocateHub() {
      if (this.IsActive.length != 0) {
        var activehublist = []
        for (var i = 0; i < this.IsActive.length; i++) {
          activehublist.push(this.IsActive[i].HubID)
        }
        this.input = ({
          "hubs": activehublist,
          "userid": this.userid
        })
        axios({
            method: 'POST',
            'url': apiUrl.api_url_hubops + 'activateHubs',
            'data': this.input,
            headers: {
              'authorization': 'authkey xB84JJ89Hd25',
            }
          })
          .then(result => {
            if (result.data.ResultCode == 100) {
              this.$alertify.success(result.data.ReturnMessage)
              this.getHubDetailslist();
            } else {
              this.$alertify.error(result.data.ReturnMessage)
            }
          }, error => {
            console.error(error)
          })
      } else {
        this.$alertify.error("Allocate Hub")
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/AllocateActiveHub/AllocateActiveHub.js